import React, { useEffect, useState } from 'react'
import { Lock, LogOut, Repeat } from 'react-feather'
import { useHistory } from 'react-router-dom'
import {
  getFulfillmentCenterSelected,
  removeFulfillmentCenterSelected,
} from 'src/services/fulfillmentCenter/fulfillmentCenterService'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from 'src/features/state'
import Icon from 'src/components/KdabraIcon'
import { buildLoginContinuePath } from 'src/services/continueNavigation'
import * as S from './UserPanel.styles'

const UserPanel = ({ user, lock, logout, onChangeFulfillmentCenter }) => {
  const [fcSelected, setFcSelected] = useState(null)
  const { assignedDock } = useSelector((state) => state.app)

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const fc = getFulfillmentCenterSelected()
    setFcSelected(fc)

    const dock = localStorage.getItem('currentDock') && JSON.parse(localStorage.getItem('currentDock'))
    if (dock) {
      dispatch(actions.setAssignedDock(dock))
    } else {
      dispatch(actions.setAssignedDock(undefined))
    }
  }, [])

  const handleChangeFulfillmentCenter = (event) => {
    event.preventDefault()

    removeFulfillmentCenterSelected()
    localStorage.removeItem('currentDock')
    setFcSelected(null)
    dispatch(actions.setAssignedDock(undefined))

    if (onChangeFulfillmentCenter) {
      onChangeFulfillmentCenter()
    }

    history.push(buildLoginContinuePath(`${history.location.pathname}${history.location.search}`))
  }

  return (
    <S.WrapperUserPanel>
      {!user?.photoURL ? (
        <Icon.CompactLight />
      ) : (
        <S.ImageIcon src={user?.photoURL} alt="Icon Sidebar User" />
      )}
      <S.TitleName>{user.displayName}</S.TitleName>
      <S.CurrentDock>{assignedDock ? `Doca ${assignedDock.code}` : 'Nenhuma doca associada'}</S.CurrentDock>
      <S.FCName>{fcSelected?.name}</S.FCName>
      <S.WrapperButtons>
        <a href="#javascript" onClick={lock}>
          <Lock /> Bloquear
        </a>
        {' | '}
        <a href="#javascript" onClick={handleChangeFulfillmentCenter}>
          <Repeat /> Trocar FC
        </a>
        {' | '}
        <a href="#javascript" onClick={logout}>
          <LogOut /> Sair
        </a>
      </S.WrapperButtons>
    </S.WrapperUserPanel>
  )
}

export default UserPanel
